import { Box, Tag } from '@factorialco/deprecated-design-system'

interface Props {
  tagName: string
}

export const OverviewTag = ({ tagName }: Props) => {
  return (
    <Box>
      <Tag type="malibu">{tagName}</Tag>
    </Box>
  )
}
